module.exports = __webpack_public_path__ + "static/p4-300f32711c238353a97be17e8f0c6891.jpg";